export default () => {
    let localHref = '';
    if (typeof window !== 'undefined') {
        localHref = location.href;
    }

    const url = `/login?redirect=${encodeURIComponent(localHref)}`;
    return url;
};
